import React from 'react';
import PropTypes from 'prop-types';
import { noop } from 'lodash';
import classNames from 'classnames';
import ContactSellerButton from '../../components/ContactSellerButton';
import { ContactSellerPopUp } from '../../components/ContactSellerPopUp';
import { ContactSellerDrawer } from '../../components/ContactSellerPopUp/ContactSellerDrawer';
import { RecipientInfo, AttachmentsUploadConfig, SenderInfo, BriefInfo, VacationInfo } from '../../context/propTypes';
import { ContextProvider } from '../../context';

import classes from './style.module.scss';

const Wrapper = ({ withTrigger, className, children }) => withTrigger ? <div className={className}>{children}</div> : children;

Wrapper.propTypes = {
    children: PropTypes.node,
    className: PropTypes.string,
    withTrigger: PropTypes.bool
};

const ContactSellerDrawerEntry = ({
    className,
    isMobile,
    recipientInfo,
    relatedGigId,
    subCategoryId,
    showInfo,
    showSpokenLanguages,
    showCountryFlag,
    pageName,
    attachmentsUploadConfig,
    isOpen = false,
    onTrigger,
    onOpen = noop,
    onClose = noop,
    onSubmitSuccess = noop,
    onSubmitFailure = noop,
    beforeOpen,
    onViewMessageClick,
    getMoreGigsData,
    offerMoreGigsEnabled,
    source,
    initialMessage = '',
    encourageAppDownloadEnabled,
    senderInfo,
    inFmpMoreGigsV4Rollout,
    withTrigger,
    sendMessage,
    inPanthersInboxMessageCreateV5Rollout,
    children,
    brief = {},
    vacation = {},
    withSatisfactionGuarantee = false
}) => {
    const componentProps = {
        drawerView: true,
        onSubmitSuccess,
        onSubmitFailure,
        Component: ContactSellerDrawer,
        isOpen,
        beforeOpen,
        onOpen,
        onClose
    };

    const hideTrigger = isOpen && !isMobile;

    const contextProps = {
        recipientInfo,
        sendMessage,
        attachmentsUploadConfig,
        relatedGigId,
        subCategoryId,
        showInfo,
        showSpokenLanguages,
        showCountryFlag,
        source,
        initialMessage,
        pageName,
        getMoreGigsData,
        offerMoreGigsEnabled,
        onViewMessageClick,
        encourageAppDownloadEnabled,
        senderInfo,
        inFmpMoreGigsV4Rollout,
        inPanthersInboxMessageCreateV5Rollout,
        brief,
        vacation,
        withSatisfactionGuarantee
    };

    return (
        <ContextProvider {...contextProps}>
            <Wrapper withTrigger={withTrigger} className={className}>
                <ContactSellerPopUp {...componentProps}/>
                {withTrigger &&
                    <>
                        {children ?
                            (
                                <div className={classNames(classes.popoverTriggerWrapper, { [classes.hideTrigger]: hideTrigger })}
                                    onClick={onTrigger}>{children}</div>
                            ) :
                            (
                                <ContactSellerButton className={classNames({ [classes.hideTrigger]: hideTrigger })}
                                    recipientInfo={recipientInfo} isMobile={isMobile} onClick={onTrigger}/>
                            )
                        }</>
                }
            </Wrapper>
        </ContextProvider>
    );
};

ContactSellerDrawerEntry.propTypes = {
    recipientInfo: RecipientInfo,
    className: PropTypes.string,
    relatedGigId: PropTypes.number,
    subCategoryId: PropTypes.number,
    attachmentsUploadConfig: AttachmentsUploadConfig,
    isMobile: PropTypes.bool,
    showInfo: PropTypes.bool,
    pageName: PropTypes.string,
    source: PropTypes.string,
    initialMessage: PropTypes.string,
    showSpokenLanguages: PropTypes.bool,
    showCountryFlag: PropTypes.bool,
    isOpen: PropTypes.bool,
    onTrigger: PropTypes.func,
    onOpen: PropTypes.func,
    onClose: PropTypes.func,
    onSubmitSuccess: PropTypes.func,
    sendMessage: PropTypes.func,
    onSubmitFailure: PropTypes.func,
    beforeOpen: PropTypes.func,
    onViewMessageClick: PropTypes.func,
    children: PropTypes.node,
    getMoreGigsData: PropTypes.func,
    offerMoreGigsEnabled: PropTypes.bool,
    encourageAppDownloadEnabled: PropTypes.bool,
    senderInfo: SenderInfo,
    inFmpMoreGigsV4Rollout: PropTypes.bool,
    withTrigger: PropTypes.bool,
    inPanthersInboxMessageCreateV5Rollout: PropTypes.bool,
    brief: BriefInfo,
    vacation: VacationInfo,
    withSatisfactionGuarantee: PropTypes.bool
};

export default ContactSellerDrawerEntry;
